import React from "react"
import { FaqAnswer } from "./faqAnswer"

const CommunityFaq = ({ items }) => {
  if (!items || !items.length) return null
  return (
    <section aria-labelledby="community-faq-title" className="rounded-lg bg-white overflow-hidden shadow p-6">
      <h2 id="community-faq-title" className="text-base font-medium text-gray-900 mb-4">
        Frequently asked questions
      </h2>
      <dl className="space-y-4">
        {items.map((item, index) => (
          <div key={index}>
            <dt className="text-sm font-semibold text-gray-900">{item.question}</dt>
            <dd className="mt-1 text-sm text-gray-600 whitespace-pre-wrap">
              {item.answerElement != null ? (
                item.answerElement
              ) : (
                <FaqAnswer text={item.answerPlain} linkTargets={item.answerLinkTargets ?? []} />
              )}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  )
}

export default CommunityFaq
